module.exports = __webpack_public_path__ + "static/media/LibraryAddGoogleMaterial.934f3dfc.svg";